import {
  AI_PREVIEW_OUTLINE_NODE_TYPE,
  BOUNDARY_EVENT_NODE_TYPE,
  BPMN_NODE_TYPE,
  NAV_AREA_NODE_TYPE,
  SEQUENCE_EDGE_TYPE,
  SWIMLANE_NODE_TYPE,
} from './bpmn-graph.mapper'
import AiPreviewOutlineNode from './components/AiPreviewOutlineNode'
import BoundaryEventNode from './components/BoundaryEventNode'
import BpmnFlowNode from './components/BpmnFlowNode'
import NavAreaNode from './components/NavAreaNode'
import NewNodePanel, { NEW_NODE_PANEL_TYPE } from './components/NewNodePanel'
import SwimlaneNode from './components/SwimlaneNode'
import SequenceEdge from './edges/SequenceEdge'

/** React Flow renderer registries — stable module constants, never per render. */
export const nodeTypes = {
  [SWIMLANE_NODE_TYPE]: SwimlaneNode,
  [BPMN_NODE_TYPE]: BpmnFlowNode,
  [BOUNDARY_EVENT_NODE_TYPE]: BoundaryEventNode,
  [NAV_AREA_NODE_TYPE]: NavAreaNode,
  [AI_PREVIEW_OUTLINE_NODE_TYPE]: AiPreviewOutlineNode,
  [NEW_NODE_PANEL_TYPE]: NewNodePanel,
}

export const edgeTypes = {
  [SEQUENCE_EDGE_TYPE]: SequenceEdge,
}

export const MIN_ZOOM = 0.05
export const MAX_ZOOM = 1.5
export const FIT_VIEW_MAX_ZOOM = 1
/** Breathing room around the fitted graph, as a fraction of the container per side. */
export const FIT_VIEW_PADDING = 0.1
